// src/utils/groupTheme.js

export function groupTheme(label) {
  switch (label) {
    /* --- Remaining cases (Best of the Best, Top Tier, etc.) unchanged --- */
    /* Paste the rest of your cases here exactly as you had them */

    default:
      return {
        wrap: {
          background: "linear-gradient(135deg, #1b1b1b, #111)",
          border: "2px solid rgba(255, 215, 0, 0.35)",
          boxShadow:
            "0 0 24px rgba(255, 215, 0, 0.15) inset, 0 12px 28px rgba(0,0,0,.45)",
        },
        titleChip: {
          background: "linear-gradient(135deg, #fac31e, #bb7300)",
          color: "#1a1a1a",
          textShadow: "none",
        },
        scoreChip: {
          background: "linear-gradient(135deg, #ffcf40, #b46f00)",
          color: "#1a1a1a",
          boxShadow: "0 0 10px rgba(255, 200, 0, .35)",
        },
        cardGlow: "0 4px 16px rgba(255, 215, 0, .2)",
      };
  }
}
